import { parseSvg } from "d3-interpolate/src/transform/parse";
export default function getTransformParametersSafari(
  transformString,
  screen,
  map
) {
  const values = parseSvg(transformString);
  let x = 0;
  let y = 0;

  ///// horizontal
  if (values.translateX <= 0) {
    //left
    x = 0;
  } else if (values.translateX < screen.width - map.width) {
    //right
    x = screen.width - map.width;
  } else x = values.translateX;

  ////// vertical

  if (values.translateY <= 0) {
    //top
    y = 0;
  } else if (
    //bottom
    values.translateY <
    screen.height - map.height
  ) {
    y = screen.height - map.height;
  } else y = values.translateY;
  return { x, y };
}
